module.exports = "/wwwroot/img/event_page.png?ver=accebad0";